import React from 'react';
import classNames from 'classnames';

// Define the props that will be added by the HOC
type WithComponentProp = {
    component?: React.ElementType;
}

type WithClassNameProp = {
  className?: string
}

const withClassNames = <TArgs extends WithClassNameProp>(
  Component: React.FC<TArgs & WithComponentProp>
) => {
  const WrappedComponent = React.forwardRef<HTMLTableCellElement | HTMLDivElement, TArgs & WithComponentProp>((props, ref) => {
    const {
      component,
      className,
      ...restProps
    } = props;
    return (
      <Component
        {...(restProps as TArgs)}
        ref={ref}
        component={(args) => <Component {...args} className={classNames(args.className, className)} />}
      />
    );
  });

  WrappedComponent.displayName = `data-table:WithClassNames(${Component.displayName || Component.name})`;

  return WrappedComponent;
};

export default withClassNames;